import { render, staticRenderFns } from "./edit-item.vue?vue&type=template&id=5b047ad8&"
import script from "./edit-item.vue?vue&type=script&lang=js&"
export * from "./edit-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports